var _process$env;

import LegacyAnalyticsListener from './LegacyAnalyticsListener';
import ModernAnalyticsListener from './ModernAnalyticsListener';
let ExportedAnalyticsListener;

if (typeof process !== 'undefined' && process !== null && (_process$env = process.env) !== null && _process$env !== void 0 && _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']) {
  ExportedAnalyticsListener = ModernAnalyticsListener;
} else {
  ExportedAnalyticsListener = LegacyAnalyticsListener;
}

export default ExportedAnalyticsListener;